import React from "react";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import apiAxios from "../api-axios";
import notify from "devextreme/ui/notify";
import {
  criarPrefeituraDs,
  criarCpbsDs,
  criarMunicipioDs,
} from "../DataSources";
import ShowError from "../AppServices";

export default class FerramentasNFSe extends React.Component {
  constructor() {
    super();

    this.cancelarNota = this.cancelarNota.bind(this);
    this.definirPrimeiraNf = this.definirPrimeiraNf.bind(this);
    this.renumerarNf = this.renumerarNf.bind(this);
    this.trocarSenha = this.trocarSenha.bind(this);
    this.bloquearCpbs = this.bloquearCpbs.bind(this);
    this.alterarCnae = this.alterarCnae.bind(this);

    this.state = {
      cancelamentoNfse: {},
      trocaMunicipioTomador: {},
      dadosPrimeiraNf: {},
      dadosRenumerarNf: {},
      dadosTrocarSenha: {},
      dadosBloquearCpbs: {},
      dadosAlterarCnae: {},
      selectedItems: [],
    };
    this.prefeituraOptions = {
      editorType: "dxSelectBox",
      dataSource: criarPrefeituraDs(),
      valueExpr: "id",
      displayExpr: "nome",
    };
    this.cpbsOptions = {
      editorType: "dxSelectBox",
      dataSource: criarCpbsDs(),
      valueExpr: "id",
      displayExpr: "fantasia",
    };
    this.municipioOptions = {
      editorType: "dxSelectBox",
      dataSource: criarMunicipioDs(),
      valueExpr: "id",
      displayExpr: "nome",
    };

    this.pathDictionary = [
      "ObterAcesso",
      "MudarSenha",
      "BloquearCpbs",
      { identificador: "DadosCnae", rota: "/nfsetools/cnae" },
      { identificador: "MudarMunicipio", rota: "/nfsetools/municipiotomador" },
      { identificador: "RptNota", rota: "/nfsetools/rptnota" },
    ];
  }

  async cancelarNota() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/cancelarnota",
        this.state.cancelamentoNfse
      );

      if (response.status === 200) {
        notify("Operação realizada com sucesso!", "success", 2000);
        this.setState({ cancelamentoNfse: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async trocarMunicipioTomador() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/municipiotomador",
        this.state.trocaMunicipioTomador
      );

      if (response.status === 200) {
        notify(
          "Troca de município do tomador realizada com sucesso!",
          "success",
          2000
        );
        this.setState({ trocaMunicipioTomador: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async definirPrimeiraNf() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/primeiranf",
        this.state.dadosPrimeiraNf
      );

      if (response.status === 200) {
        notify("Primeira NF definida com sucesso!", "success", 2000);
        this.setState({ dadosPrimeiraNf: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async renumerarNf() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/renumerarnf",
        this.state.dadosRenumerarNf
      );

      if (response.status === 200) {
        notify("NF renumerada com sucesso!", "success", 2000);
        this.setState({ dadosRenumerarNf: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async trocarSenha() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/trocarsenha",
        this.state.dadosTrocarSenha
      );

      if (response.status === 200) {
        notify("NF renumerada com sucesso!", "success", 2000);
        this.setState({ dadosTrocarSenha: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async bloquearCpbs() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/bloquearcpbs",
        this.state.dadosBloquearCpbs
      );

      if (response.status === 200) {
        notify("CPBS bloqueado com sucesso!", "success", 2000);
        this.setState({ dadosBloquearCpbs: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  async alterarCnae() {
    try {
      const response = await apiAxios.post(
        "/nfsetools/alterarcnae",
        this.state.dadosAlterarCnae
      );

      if (response.status === 200) {
        notify("CPBS bloqueado com sucesso!", "success", 2000);
        this.setState({ dadosAlterarCnae: {} });
      }
    } catch (error) {
      ShowError(error.response.data);
      notify(error, "error", 2000);
    }
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <h3>Ferramentas NFS-e</h3>

        <div style={{ padding: "20px" }}>
          <br />
          <div>
            <h3>Cancelar NFS-e</h3>
            <form>
              <Form
                formData={this.state.cancelamentoNfse}
                colCount={3}
                labelLocation={"top"}
              >
                <SimpleItem
                  dataField={"municipioId"}
                  editorType={"dxLookup"}
                  editorOptions={this.municipioOptions}
                  colSpan={1}
                >
                  <Label text="Municipio" />
                </SimpleItem>
                <SimpleItem dataField={"cpfCnpjCpbs"} colSpan={1}>
                  <Label text="CPBS" />
                </SimpleItem>
                <SimpleItem dataField={"nfseNumero"} colSpan={1}>
                  <Label text="Nº da NFS-e" />
                </SimpleItem>
              </Form>
            </form>
          </div>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.cancelarNota()}
            />
          </div>
        </div>

        <div style={{ padding: "20px" }}>
          <h3>Trocar Município Tomador</h3>
          <form>
            <Form
              formData={this.state.trocaMunicipioTomador}
              colCount={4}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField={"municipioPrefeituraId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
                colSpan={1}
              >
                <Label text="Prefeitura" />
              </SimpleItem>
              <SimpleItem dataField={"cpfCnpjCpbs"} colSpan={1}>
                <Label text="CPBS" />
              </SimpleItem>
              <SimpleItem dataField={"nfseNumero"} colSpan={1}>
                <Label text="Nº da NFS-e" />
              </SimpleItem>
              <SimpleItem
                dataField={"municipioTomadorId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
                colSpan={1}
              >
                <Label text="Novo Município" />
              </SimpleItem>
            </Form>
          </form>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.trocarMunicipioTomador()}
            />
          </div>
        </div>

        <div style={{ padding: "20px" }}>
          <h3>Primeira NF - Cuidado, exclusão de notas não tem volta!</h3>
          <form>
            <Form
              formData={this.state.dadosPrimeiraNf}
              colCount={6}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField={"municipioId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
                colSpan={1}
              >
                <Label text="Prefeitura" />
              </SimpleItem>
              <SimpleItem dataField={"cpfCnpjCpbs"} colSpan={1}>
                <Label text="CPBS" />
              </SimpleItem>
              <SimpleItem dataField={"nome"} colSpan={2}>
                <Label text="Razão Social" />
              </SimpleItem>
              <SimpleItem dataField={"numero"} colSpan={1}>
                <Label text="Última NF" />
              </SimpleItem>
              <SimpleItem
                dataField={"excluirNfs"}
                editorType={"dxCheckBox"}
                colSpan={1}
              >
                <Label text="Excluir NF's" />
              </SimpleItem>
            </Form>
          </form>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.definirPrimeiraNf()}
            />
          </div>
        </div>

        <div style={{ padding: "20px" }}>
          <h3>Renumerar NF</h3>
          <form>
            <Form
              formData={this.state.dadosRenumerarNf}
              colCount={6}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField={"municipioId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
                colSpan={1}
              >
                <Label text="Prefeitura" />
              </SimpleItem>
              <SimpleItem dataField={"cpfCnpjCpbs"} colSpan={1}>
                <Label text="CPBS" />
              </SimpleItem>
              <SimpleItem dataField={"nome"} colSpan={2}>
                <Label text="Razão Social" />
              </SimpleItem>
              <SimpleItem dataField={"numero"} colSpan={1}>
                <Label text="Nº NF" />
              </SimpleItem>
              <SimpleItem dataField={"novoNumero"} colSpan={1}>
                <Label text="Nº Novo" />
              </SimpleItem>
            </Form>
          </form>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.renumerarNf()}
            />
          </div>
        </div>

        <div style={{ padding: "20px" }}>
          <h3>Trocar senha</h3>
          <form>
            <Form
              formData={this.state.dadosTrocarSenha}
              colCount={5}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField={"municipioId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
                colSpan={1}
              >
                <Label text="Prefeitura" />
              </SimpleItem>
              <SimpleItem dataField={"cpfCnpjCpbs"} colSpan={1}>
                <Label text="CPBS" />
              </SimpleItem>
              <SimpleItem dataField={"nome"} colSpan={2}>
                <Label text="Razão Social" />
              </SimpleItem>
              <SimpleItem dataField={"senha"} colSpan={1}>
                <Label text="Nova Senha" />
              </SimpleItem>
            </Form>
          </form>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.trocarSenha()}
            />
          </div>
        </div>

        <div style={{ padding: "20px" }}>
          <h3>Bloquear CPBS</h3>
          <form>
            <Form
              formData={this.state.dadosBloquearCpbs}
              colCount={5}
              labelLocation={"top"}
            >
              <SimpleItem
                dataField={"municipioId"}
                editorType={"dxLookup"}
                editorOptions={this.municipioOptions}
                colSpan={1}
              >
                <Label text="Prefeitura" />
              </SimpleItem>
              <SimpleItem dataField={"cpfCnpjCpbs"} colSpan={1}>
                <Label text="CPBS" />
              </SimpleItem>
              <SimpleItem dataField={"nome"} colSpan={2}>
                <Label text="Razão Social" />
              </SimpleItem>
              <SimpleItem dataField={"motivo"} colSpan={2}>
                <Label text="Motivo" />
              </SimpleItem>
            </Form>
          </form>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.bloquearCpbs()}
            />
          </div>
        </div>

        <br />

        <div style={{ padding: "20px" }}>
          <h3>Alterar CNAE</h3>
          <form>
            <Form
              formData={this.state.dadosAlterarCnae}
              colCount={5}
              labelLocation={"top"}
            >
              <SimpleItem dataField={"cnae"} colSpan={2}>
                <Label text="CNAE" />
              </SimpleItem>
              <SimpleItem dataField={"codigoServico"} colSpan={2}>
                <Label text="Cód. Serviço (ex.: 16.01)" />
              </SimpleItem>
            </Form>
          </form>

          <div
            style={{
              display: "flex",
              marginTop: "25px",
              justifyContent: "center",
              alignContent: "center",
              justifyItems: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="success"
              text="Confirmar"
              width={200}
              onClick={() => this.alterarCnae()}
            />
          </div>
        </div>
      </div>
    );
  }
}
